module.exports = __webpack_public_path__ + "img/status-scheduled.61d6eb6e.png";